import {api} from "../../core/api/axios/baseAxios"
import { Routes } from "../../core/routes/apiRoutes";

const requestDemo = async (data) => {
    const response = await api.post(Routes.createDemoRequestUrl, data);
    const resData = response.data;
    return resData.data;
}

const demoRequestService = {
    requestDemo,
}

export default demoRequestService